(function () {
  if (window.__bossCartCheckoutInit) return;
  window.__bossCartCheckoutInit = true;

  const AUTO_RAZORPAY_KEY = 'boss_auto_razorpay';
  const AUTO_RAZORPAY_MAX_AGE_MS = 60000;
  const BACKUP_KEY = 'boss_buy_now_cart_backup';
  const ITEM_KEY = 'boss_buy_now_item';
  const ACTIVE_KEY = 'boss_buy_now_active_at';
  const PHASE_KEY = 'boss_buy_now_phase';
  const BUY_NOW_ACTIVE_MAX_AGE_MS = 30 * 60 * 1000;
  const RESTORE_SOURCE = 'boss-buy-now-restore';

  function closeOpenCartDrawer() {
    const drawer = document.querySelector('cart-drawer-component');
    if (!drawer?.refs?.dialog?.open) return;

    if (typeof drawer.closeDialogImmediately === 'function') {
      drawer.closeDialogImmediately();
      return;
    }

    drawer.close();
  }

  function isUserClickInsideOpenDrawer(event, button) {
    if (!event.isTrusted) return false;

    const openDrawer = document.querySelector('.cart-drawer__dialog[open]');
    return Boolean(openDrawer && openDrawer.contains(button));
  }

  document.addEventListener(
    'click',
    function (event) {
      const internationalBtn = event.target.closest('#international-checkout');

      if (internationalBtn) {
        if (!event.isTrusted) return;

        sessionStorage.setItem('skip_magic_checkout', '1');
        window.location.href = '/checkout';
        return;
      }

      const razorpayBtn = event.target.closest('.razorpay-trigger');

      if (
        razorpayBtn &&
        !razorpayBtn.disabled &&
        isUserClickInsideOpenDrawer(event, razorpayBtn)
      ) {
        sessionStorage.removeItem('skip_magic_checkout');
        closeOpenCartDrawer();
      }
    },
    true
  );

  function consumeAutoRazorpayFlag() {
    const raw = sessionStorage.getItem(AUTO_RAZORPAY_KEY);
    if (!raw) return false;

    sessionStorage.removeItem(AUTO_RAZORPAY_KEY);

    const timestamp = Number(raw);
    if (!timestamp || Number.isNaN(timestamp)) return false;

    return Date.now() - timestamp <= AUTO_RAZORPAY_MAX_AGE_MS;
  }

  function tryAutoRazorpayCheckout() {
    if (window.location.pathname !== '/cart') return;
    if (!consumeAutoRazorpayFlag()) return;

    sessionStorage.removeItem('skip_magic_checkout');

    function attempt(attemptsLeft) {
      const checkoutBtn = document.getElementById('checkout');
      if (checkoutBtn && !checkoutBtn.disabled) {
        checkoutBtn.click();
        return;
      }
      if (attemptsLeft <= 0) return;
      window.setTimeout(function () {
        attempt(attemptsLeft - 1);
      }, 200);
    }

    window.setTimeout(function () {
      attempt(15);
    }, 400);
  }

  function clearBuyNowState() {
    localStorage.removeItem(BACKUP_KEY);
    localStorage.removeItem(ITEM_KEY);
    localStorage.removeItem(ACTIVE_KEY);
    sessionStorage.removeItem(PHASE_KEY);
  }

  function isCheckoutPath() {
    return (
      window.location.pathname.startsWith('/checkout') ||
      window.location.pathname.includes('/checkouts/')
    );
  }

  function isThankYouPath() {
    return (
      window.location.pathname.includes('thank') ||
      window.location.search.includes('thank_you') ||
      window.location.search.includes('thank-you')
    );
  }

  function isBuyNowFlowActive() {
    const raw = localStorage.getItem(ACTIVE_KEY);
    if (!raw) return false;

    const timestamp = Number(raw);
    if (!timestamp || Number.isNaN(timestamp)) {
      clearBuyNowState();
      return false;
    }

    if (Date.now() - timestamp > BUY_NOW_ACTIVE_MAX_AGE_MS) {
      clearBuyNowState();
      return false;
    }

    return sessionStorage.getItem(PHASE_KEY) === 'checkout';
  }

  function shouldAttemptRestore() {
    if (!isBuyNowFlowActive()) return false;
    if (isThankYouPath()) return false;
    if (isCheckoutPath()) return false;

    const path = window.location.pathname;
    if (path === '/cart') return false;

    return true;
  }

  function parseStoredJson(key) {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    try {
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  function getCartSectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component'))
      .map(function (el) {
        return el.dataset.sectionId;
      })
      .filter(Boolean);
  }

  function notifyCartUpdated(cart, sections) {
    const itemCount = cart && cart.item_count != null ? cart.item_count : 0;

    sessionStorage.setItem(
      'cart-count',
      JSON.stringify({
        value: String(itemCount),
        timestamp: Date.now(),
      })
    );

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: RESTORE_SOURCE,
          data: {
            itemCount: itemCount,
            source: RESTORE_SOURCE,
            sections: sections,
          },
        },
      })
    );
  }

  async function fetchCart() {
    const response = await fetch('/cart.js', {
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Could not read cart');
    }

    return response.json();
  }

  function buildMissingItems(cart, backup, buyNowItem) {
    const currentVariantIds = new Set(
      cart.items.map(function (item) {
        return String(item.variant_id);
      })
    );

    const missingItems = [];

    if (Array.isArray(backup)) {
      backup.forEach(function (item) {
        if (!currentVariantIds.has(String(item.id))) {
          missingItems.push(item);
        }
      });
    }

    if (buyNowItem && buyNowItem.id && !currentVariantIds.has(String(buyNowItem.id))) {
      missingItems.push({
        id: Number(buyNowItem.id),
        quantity: Number(buyNowItem.quantity) || 1,
      });
    }

    return missingItems;
  }

  let restorePromise = null;

  async function restoreBuyNowCart() {
    if (!shouldAttemptRestore()) {
      if (isThankYouPath() && isBuyNowFlowActive()) {
        clearBuyNowState();
      }
      return;
    }

    const backup = parseStoredJson(BACKUP_KEY) || [];
    const buyNowItem = parseStoredJson(ITEM_KEY);

    if (!Array.isArray(backup)) {
      clearBuyNowState();
      return;
    }

    if (backup.length === 0 && !buyNowItem) {
      clearBuyNowState();
      return;
    }

    const cart = await fetchCart();
    const missingItems = buildMissingItems(cart, backup, buyNowItem);

    if (missingItems.length === 0) {
      clearBuyNowState();
      notifyCartUpdated(cart);
      return;
    }

    const body = {
      items: missingItems,
    };

    const sectionIds = getCartSectionIds();
    if (sectionIds.length) {
      body.sections = sectionIds.join(',');
      body.sections_url = window.location.pathname + window.location.search;
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    });

    const addData = await response.json().catch(function () {
      return {};
    });

    if (!response.ok) {
      throw new Error(addData.description || addData.message || 'Could not restore cart');
    }

    const updatedCart = await fetchCart();
    clearBuyNowState();
    notifyCartUpdated(updatedCart, addData.sections);
  }

  function tryRestoreBuyNowCart() {
    if (restorePromise) return restorePromise;

    restorePromise = restoreBuyNowCart()
      .catch(function (error) {
        console.error('[Buy Now restore]', error);
      })
      .finally(function () {
        restorePromise = null;
      });

    return restorePromise;
  }

  function initCartCheckoutHelpers() {
    tryAutoRazorpayCheckout();
    tryRestoreBuyNowCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartCheckoutHelpers);
  } else {
    initCartCheckoutHelpers();
  }

  window.addEventListener('pageshow', function () {
    tryRestoreBuyNowCart();
  });
})();
